module.exports = __webpack_public_path__ + "img/coming-soon.3f45b450.jpg";